import { Grid, GridColumn } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ITranslateStore } from '../../../stores/TranslateStore';
import BoxNotice from '../../common/BoxNotice';

interface IPreviousInvoicesFailedToLoadNoticeProps {
  translateStore?: ITranslateStore;
}

@inject('translateStore')
@observer
export default class PreviousInvoicesFailedToLoadNotice extends React.Component<IPreviousInvoicesFailedToLoadNoticeProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;

    return (
      <BoxNotice type="error">
        <Grid align={['between-xs']}>
          <GridColumn width={['xs']}>{translate('invoices.previous-invoices.errors.previous-invoices-failed-to-load')}</GridColumn>
        </Grid>
      </BoxNotice>
    );
  }
}
